import React, { useState, useEffect } from 'react';
import SideBarAccordian from './SideBarAccordian';
import { Image } from 'react-bootstrap';
import { useAuth } from '../auth/Auth';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import './companion.-prompt.css';
import { DEPENDENT_TREE_ROUTE } from '../../constants/routes.constants';
import Left_sidebar_tree from '../../assets/images/New_Change_Img/Left_sidebar_tree.png';

const LeftSideBar = (props) => {
  const [showLayout, setShowLayout] = useState(true);
  const { partner, school, dependent } = useAuth();
  const [width, setWidth] = useState(window.innerWidth);
  const [mobileDisplay, setMobileDisplay] = useState('');
  const [collapseClass, setCollapseClass] = useState(
    isMobile ? '' : showLayout ? '' : 'collapsse'
  );
  const history = useHistory();
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  const setCollapsse = () => {
    if (showLayout) {
      props.setLeftCollapsse('left-collapsse');
      setCollapseClass('collapsse');
    } else {
      props.setLeftCollapsse('');
      setCollapseClass('');
    }
    setShowLayout(!showLayout);
  };

  useEffect(() => {
    if (isMobile && width < 1200) {
      console.warn('dfd', width, isMobile);
      if (props.rightCollapsse === 'right-collapsse') {
        setMobileDisplay('none');
      } else {
        setMobileDisplay('');
      }
    }
  }, [props.rightCollapsse]);

  const handleTreeClick = () => {
    if (dependent?.username) {
      history.push(`${DEPENDENT_TREE_ROUTE}/${dependent?.username}`);
    } else {
      history.push(DEPENDENT_TREE_ROUTE);
    }
  };

  return (
    <div
      style={{ display: mobileDisplay }}
      className={`flex-col-left ${collapseClass}`}
    >
      <div className="challenges-left-accordian">
        {partner || school ? (
          <span className="back-btn" onClick={() => history.goBack()}>
            <HiOutlineChevronLeft />
          </span>
        ) : (
          <>
            {props.myInterests && (
              <div className="accordian-col my-interests">
                <div className="accordian-head">
                  <span className="hide-on-toggle">My TaleTree :</span>
                  <span className={`dropdown-ic ${collapseClass}`}>
                    <a
                      className="left-dropdown-btn"
                      href="#"
                      onClick={setCollapsse}
                    >
                      &nbsp; &nbsp;
                    </a>
                  </span>
                  {/* <Search {...props} /> */}
                </div>
                <div className="accordian-body  hide-on-toggle">
                  <div className="left_tree">
                    <Image
                      className="center_img_sidebar add-pointer"
                      onClick={handleTreeClick}
                      src={Left_sidebar_tree}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            )}
            <SideBarAccordian
              name="My Interest Branches"
              type="branch"
              {...props}
            />
            <SideBarAccordian name="Treehouses" type="treehouses" {...props} />
          </>
        )}
      </div>
    </div>
  );
};

export default LeftSideBar;
